import React from "react";
import { InputNumber } from "antd";
import { currencySymbol } from "./money";

/** Amount input in euros (or `currency`) that reads and writes integer cents. */
const MoneyInput = ({ value, onChange, currency = "EUR", ...rest }) => (
  <InputNumber
    style={{ width: "100%" }}
    value={value === null || value === undefined ? null : value / 100}
    onChange={v => onChange?.(v === null || v === undefined ? null : Math.round(Number(v) * 100))}
    decimalSeparator=","
    precision={2}
    step={1}
    formatter={v => (v === undefined || v === null || v === "" ? "" : String(v).replace(".", ","))}
    parser={v =>
      String(v || "")
        .replace(/\./g, "")
        .replace(",", ".")
    }
    addonAfter={currencySymbol(currency)}
    {...rest}
  />
);

export default MoneyInput;
